var tag = document.createElement('script');
var player;

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function onYouTubeIframeAPIReady() {

    if (ramVideos.length > 0) {
        for (var x = 0; x < ramVideos.length; x++) {
            player = new YT.Player(ramVideos[x][0], {
                height: '100%',
                width: '100%',
                videoId: ramVideos[x][1],
                playerVars: {
                    // start: 0,
                    // end: 10,
                    loop: 1,
                    playlist: ramVideos[x][1],
                    rel: '0',
                    iv_load_policy: '3',
                    controls: 0,
                    playsinline: 1,
                    disablekb: 0
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
        }
    }

}

function onPlayerReady(event) {
    event.target.playVideo();
    event.target.mute();
}

function onPlayerStateChange(event) {
}

jQuery(document).ready( function () {
  if ( jQuery('.slick-dots').lenght > 0 ) {
    if ( jQuery('.slick-dots > li').length == 1) {
      jQuery('.slick-dots').hide();
    }
  }
});